import React, { useState, useEffect } from 'react';
import { MdNotifications, MdInfo, MdEvent, MdWarning, MdSearch } from 'react-icons/md';
import api from '../api/axios';

export default function NoticeBoard() {
    const [notices, setNotices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState('all');

    useEffect(() => {
        fetchNotices();
    }, []);

    const fetchNotices = async () => {
        try {
            const res = await api.get('/notices');
            setNotices(res.data);
        } catch (error) {
            console.error("Failed to fetch notices");
        } finally {
            setLoading(false);
        }
    };

    const getIcon = (type) => {
        switch (type) {
            case 'urgent': return <MdWarning className="text-red-500" size={24} />;
            case 'event': return <MdEvent className="text-blue-500" size={24} />;
            default: return <MdInfo className="text-gray-500" size={24} />;
        }
    };

    const getBgColor = (type) => {
        switch (type) {
            case 'urgent': return 'bg-red-50 border-red-100';
            case 'event': return 'bg-blue-50 border-blue-100';
            default: return 'bg-white border-gray-200';
        }
    };

    const filteredNotices = notices.filter(n => filter === 'all' || n.type === filter);

    return (
        <div className="max-w-4xl mx-auto p-4 md:p-6 pb-24">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-6">
                <div>
                    <h1 className="text-2xl font-bold flex items-center gap-2 text-gray-800">
                        <MdNotifications className="text-blue-600" /> Notice Board
                    </h1>
                    <p className="text-gray-500 text-sm">Updates & official announcements from Head Office</p>
                </div>

                <div className="flex bg-gray-100 p-1 rounded-lg">
                    {['all', 'general', 'urgent', 'event'].map(f => (
                        <button
                            key={f}
                            onClick={() => setFilter(f)}
                            className={`px-4 py-1.5 rounded-md text-sm font-medium transition-all ${filter === f ? 'bg-white text-blue-600 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}
                        >
                            {f.charAt(0).toUpperCase() + f.slice(1)}
                        </button>
                    ))}
                </div>
            </div>

            {loading ? (
                <div className="text-center py-12 text-gray-400">Loading notices...</div>
            ) : filteredNotices.length === 0 ? (
                <div className="text-center py-12 bg-white rounded-xl border border-gray-100 shadow-sm">
                    <MdNotifications size={48} className="mx-auto text-gray-200 mb-2" />
                    <p className="text-gray-500">No notices found.</p>
                </div>
            ) : (
                <div className="space-y-4">
                    {filteredNotices.map(notice => (
                        <div key={notice.id} className={`p-5 rounded-xl border shadow-sm transition-all hover:shadow-md ${getBgColor(notice.type)}`}>
                            <div className="flex items-start gap-4">
                                <div className="mt-1 bg-white p-2 rounded-full shadow-sm">
                                    {getIcon(notice.type)}
                                </div>
                                <div className="flex-1">
                                    <div className="flex justify-between items-start">
                                        <h3 className="font-bold text-gray-800 text-lg mb-1">{notice.title}</h3>
                                        <span className="text-xs text-gray-400 whitespace-nowrap bg-white/50 px-2 py-1 rounded-md">
                                            {new Date(notice.created_at).toLocaleDateString()}
                                        </span>
                                    </div>
                                    <p className="text-gray-600 leading-relaxed text-sm md:text-base whitespace-pre-line">
                                        {notice.content}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
